import React from "react";
import { Link } from "react-router-dom";
import AeroHeader from "../../components/aero/AeroHeader";
import MovmoIdentityChip from "../../components/MovmoIdentityChip";
import { useMockMode } from "../../hooks/useMockMode";

const AeroLanding: React.FC = () => {
    // First page in the Aero flow — calling useMockMode here captures the
    // ?mock=true URL flag into sessionStorage so subsequent pages
    // (results, checkout) see it without needing the param re-passed.
    useMockMode();

    return (
        <div
            className="min-h-screen flex flex-col"
            style={{
                fontFamily:
                    '"Haas Grot Disp Web", "Haas Grot Text Web", "Helvetica Neue", Helvetica, Arial, sans-serif',
                background:
                    "linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 50%, #1A1A1A 100%)",
            }}
        >
            {/* Hero background with image fallback */}
            <div
                className="flex-1 flex flex-col bg-cover bg-center relative"
                style={{
                    backgroundImage:
                        "url('/images/aero/hero-bg.png'), linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 50%, #1A1A1A 100%)",
                }}
            >
                {/* Header */}
                <AeroHeader />

                {/* One-click Movmo identity chip (landing only). The SDK owns its
                    placement: a fixed slot at left 40 / bottom 28, z 9999. */}
                <MovmoIdentityChip airline="aero" noticeColor="#d6d3d1" />

                {/* Hero content — absolute bottom-left, matching Aero's layout */}
                <div className="flex-1 relative">
                    {/* bottom 80 clears the SDK chip slot in both states: slot
                        bottom 28 + chip height 36 (anonymous chip and recognized
                        banner are both h-9) + 16 gap = 80. */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: 80,
                            left: 28,
                            paddingLeft: 32,
                        }}
                    >
                        <div>
                            {/* H1: "East Coast Expansion" — 40px, weight 400, lh 48px, ls -0.16px */}
                            <h1
                                style={{
                                    fontSize: 40,
                                    fontWeight: 400,
                                    lineHeight: "48px",
                                    letterSpacing: "-0.16px",
                                    color: "#fff",
                                    margin: 0,
                                }}
                            >
                                East Coast Expansion
                            </h1>
                            {/* H2: "Miami Debuts This November" — same style */}
                            <h2
                                style={{
                                    fontSize: 40,
                                    fontWeight: 400,
                                    lineHeight: "48px",
                                    letterSpacing: "-0.16px",
                                    color: "#fff",
                                    margin: 0,
                                }}
                            >
                                Miami Debuts This November
                            </h2>

                            {/* "Explore Flights" link — mt 28px, pb 12px */}
                            <Link
                                to="/aero/flights"
                                className="inline-flex items-center group"
                                style={{ marginTop: 28, paddingBottom: 12 }}
                            >
                                {/* Text: 16px, weight 500, white, capitalize */}
                                <span
                                    style={{
                                        fontSize: 16,
                                        fontWeight: 500,
                                        lineHeight: "20px",
                                        color: "#fff",
                                        textTransform: "capitalize" as const,
                                    }}
                                >
                                    Explore Flights
                                </span>
                                {/* Arrow: 24x24, orange (#ff6a00), Aero's actual arrow SVG */}
                                <svg
                                    className="ml-1 group-hover:translate-x-1 transition-transform duration-300"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 48 48"
                                    fill="rgb(255, 106, 0)"
                                >
                                    <path d="M28.12 39.85 41 23.93 28.12 8H22.8l10.51 13.64H9v4.58h24.31l-10.5 13.63h5.31Z" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AeroLanding;
